import React, { lazy, Suspense, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import PrivateRouting from '@routes/PrivateRouting';
import { doAuthentication } from '@services/auth/Auth';
import Layout from '@components/layout/Layout';
import { smartlookConsent, smartlookError, smartlookIdentify, smartLookInit } from '@utils/smartlook';
import { getCompanies, CompanyType } from '@context/CompaniesContext';
import { Loading as CoreLoading, SvgIcon } from '@agilize/components-core';
import { GradientOverlay } from '@styles/generic/shared.styles';
import { zendeskchatInit } from '@utils/zendesk';
import WhatsappChatButton from '@components/whatsappChatButton/WhatsappChatButton';
import AppProvider, { AuthProviderData } from './AppProvider';
import { logout } from '../services/auth/Auth';

const Toast = lazy(() => import('./utils/toastHelper').then(({ StyledToastContainer }) => ({ default: StyledToastContainer })));

const App = () => {
  const [loading, setLoading] = useState(true);
  const [authData, setAuthData] = useState<AuthProviderData>({
    userData: { name: '', email: '', tenant: [], sub: '' },
  });

  useEffect(() => {
    (async () => {
      const authResponse = await doAuthentication();

      if (!authResponse) {
        return logout();
      }

      const { isAuthenticated, userData } = authResponse;

      if (isAuthenticated) {
        setAuthData({ userData });
        // zendeskchatInit();
        setLoading(false);

        if (process.env.NODE_ENV !== 'development') {
          smartLookInit();
          smartlookConsent();
          smartlookIdentify(userData.sub, { id: userData.sub, name: userData.name, email: userData.email });
          window.onerror = msg => {
            smartlookError(msg);
          };
        }
      }
    })();
    // TODO: Verificar se já houve o pagamento, se sim redireciona para o onboarding se não vai para a tela de pagamento
  }, []);

  const COUNTRY_CODE = '55';
  const PHONE_NUMBER = '7199293693';

  return (
    <Layout>
      {loading ? (
        <GradientOverlay data-testid="loading-status" className="centered-content centered-content__full">
          <CoreLoading size={100} />
        </GradientOverlay>
      ) : (
        <AppProvider authData={authData}>
          <PrivateRouting />
          <Suspense fallback={<></>}>
            <Toast />
          </Suspense>
          <WhatsappChatButton countryCode={COUNTRY_CODE} phoneNumber={PHONE_NUMBER} message="Preciso de ajuda no formulário" animated={false} />
        </AppProvider>
      )}
    </Layout>
  );
};

export default App;
